import { useId, type ReactNode, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { describedBy, Field } from './Field';
import styles from './form.module.css';

interface SelectInputProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  label: string;
  hint?: ReactNode;
  error?: string;
  options: Array<{ value: string; label: string }>;
}

/** Native select: the most familiar picker on every phone. */
export function SelectInput({ label, hint, error, options, ...rest }: SelectInputProps) {
  const id = useId();
  return (
    <Field id={id} label={label} hint={hint} error={error}>
      <div className={styles.selectWrap}>
        <select
          id={id}
          className={styles.input}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(id, hint, error)}
          {...rest}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown aria-hidden="true" className={styles.selectIcon} />
      </div>
    </Field>
  );
}
